'use client';

import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@/lib/i18n';
import RelatedMarkets from './RelatedMarkets';
import { AssetOverview } from './AssetOverview';
import WalletController from './WalletController';
import { AssetChartCard } from './AssetChartCard';
import { useRightDrawer } from '@/contexts/DrawerContext';
import useSWR from 'swr';
import { useHeader, useTransparentHeader } from '@/contexts/HeaderContext';
import { useMount } from 'ahooks';
import { cn } from '@/lib/utils';
import { useTrackingWallets } from '@/contexts/TrackingWalletsProvider';
import MarketPulse from '../ui/MarketPulse';
import PythraSummary from '../ui/PythraSummary';
import FixedChatWindow from '../message/FixedChatWindow';
import StrategyPanel from './StrategyPanel';
import PortfolioSidebarRender from './PortfolioSidebarRender';
import PortfolioTrackRender from './PortfolioTrackRender';

export default function MonitorPortfolio({ openInSidebar }: { openInSidebar?: boolean }) {
  const { wallets } = useTrackingWallets();

  useTransparentHeader(false);

  const activeWallets = useMemo(() => {
    if (wallets.systemWallet) {
      return [wallets.systemWallet];
    }
    return [];
  }, [wallets.systemWallet]);
  // const portfolioTrendingCard = useMemo(() => {
  //   if (!report?.portfolioData) return null;

  //   return {
  //     type: 'event-portfolio',
  //     id: '-1',
  //     title: report?.suggestions?.title || t("Today's portfolio suggestions"),
  //     weight: 0,
  //     icon: '',
  //     portfolioId: '-1',
  //     totalValue: report.portfolioData.totalValue,
  //     priceChange24h: report.portfolioData.change24h?.percentage,
  //     priceChangeAmount: report.portfolioData.change24h?.value,
  //     stats: {
  //       marketsCount: report.portfolioData.marketsCount,
  //       assetsCount: report.portfolioData.assetsCount,
  //     },
  //   };
  // }, [report, t]);

  return (
    <>
      <div
        className={cn(
          'space-y-4 pt-5 pb-30 max-w-245 mx-auto',
          !openInSidebar ? 'w-[calc(100vw-710px)]' : '',
        )}
      >
        <AssetOverview trackedWallets={activeWallets} type="portfolio" dir="vertical" />
        <AssetChartCard trackedWallets={activeWallets} openInSidebar={openInSidebar} />
        <StrategyPanel />
        {/* <PythraSummary summary={report?.summary} loading={isReportLoading} /> */}
        {/* <RelatedMarkets trackedWallets={activeWallets} openInSidebar={openInSidebar} /> */}
      </div>

      {!openInSidebar && (
        <>
          <PortfolioTrackRender />
          <PortfolioSidebarRender />
        </>
      )}

      {/* {false && (
        <FixedChatWindow
          suggestions={report?.recommended_questions || []}
          sourceId={`portfolio`}
          userContext={
            report
              ? JSON.stringify({
                  context_type: 'portfolio',
                  data: {
                    report,
                    portfolioData: report.portfolioData,
                    trending_card: portfolioTrendingCard,
                  },
                })
              : undefined
          }
        />
      )} */}
    </>
  );
}
